import { Calendar, Users, Award, ArrowRight } from 'lucide-react';
import data from './Streams.json';
import { Link } from 'react-router-dom';
import './StreamsDB.css';

const StreamsDB = () => {
  return (
    <section className="streams-section">
      <div className="streams-header">
        <Calendar className="header-icon" size={40} />
        <h1>Как мы провели предыдущие потоки</h1>
      </div>

      <div className="streams-container">
        {data.length > 0 && (
          <div className="streams-grid">
            {data.map((items) => (
              <div className="stream-card" key={items.id}>
                {/* Остальной код карточки остается без изменений */}
                <div className="stream-badge">
                  <span>{items.number_of_stream} поток</span>
                  <div className="stream-year">{items.year}</div>
                </div>

                <div className="stream-stats">
                  <div className="stat-item">
                    <Users className="stat-icon" />
                    <div>
                      <div className="stat-value">{items.requests}</div>
                      <div className="stat-label">поступило заявок</div>
                    </div>
                  </div>

                  <div className="stat-item">
                    <Users className="stat-icon" />
                    <div>
                      <div className="stat-value">{items.teams}</div>
                      <div className="stat-label">команд участвовало</div>
                    </div>
                  </div>

                  <div className="stat-item">
                    <Award className="stat-icon" />
                    <div>
                      <div className="stat-value">{items.prize_money}</div>
                      <div className="stat-label">призовой фонд</div>
                    </div>
                  </div>
                </div>

                <Link to={`/streams${items.id}`} className="stream-link">
                  Подробнее <ArrowRight className="link-icon" />
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default StreamsDB;